import { render, staticRenderFns } from "./SvgV2Section08.vue?vue&type=template&id=47d32cdd&"
import script from "./SvgV2Section08.vue?vue&type=script&lang=js&"
export * from "./SvgV2Section08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports